/**
 * Automatically check all boxes in the cookie banner (essential and non-essential) overriding Shopify's default behavior.
 * This just checks the boxes, it doesn't set the tracking preferences, this is done when user clicks the Save My Choice button.
 */

function checkConsentBoxes() {
  const checkboxes = document.querySelectorAll(
    'input[id^="shopify-pc__prefs__"][type="checkbox"]:not(:checked):not([disabled])'
  );
  if (checkboxes.length === 0) return false;
  checkboxes.forEach((cb) => {
    cb.checked = true;
    cb.dispatchEvent(new Event("change", { bubbles: true }));
  });
  return true;
}
if (typeof MutationObserver !== "undefined" && document.body) {
  if (!checkConsentBoxes()) {
    const observer = new MutationObserver(() => {
      if (checkConsentBoxes()) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
}
